import { z } from 'zod';

export const ResetPasswordSchema = z
    .object({
        email: z.string().email({ message: 'البريد الإلكتروني مطلوب ويجب أن يكون صالحًا' }),
        token: z.string().min(1, { message: 'رمز إعادة تعيين كلمة المرور مطلوب' }),
        password: z.string().min(6, { message: 'يجب أن تكون كلمة المرور الجديدة على الأقل 6 أحرف' }),
        password_confirmation: z.string().min(1, { message: 'يجب تأكيد كلمة المرور الجديدة' }),
    })
    .refine((data) => data.password === data.password_confirmation, {
        message: 'كلمات المرور غير متطابقة',
        path: ['password_confirmation'],
    });
